import React from "react";
import { Box, Typography, Card, CardContent } from "@mui/material";

const SummaryCard = ({ icon, label, value, gradient, caption, footer }) => (
  <Card sx={{ height: "100%", background: gradient }}>
    <CardContent>
      <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
        {icon && React.cloneElement(icon, { sx: { color: "white", mr: 1, ...icon.props.sx } })}
        <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.9)" }}>
          {label}
        </Typography>
      </Box>
      <Typography variant="h4" sx={{ color: "white", fontWeight: 700 }}>
        {value}
      </Typography>
      {caption && (
        <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.8)", mt: 1 }}>
          {caption}
        </Typography>
      )}
      {footer}
    </CardContent>
  </Card>
);

export default SummaryCard;
